exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oh_loader_A {\r\n    position: fixed;\r\n    top: 0px;\r\n    z-index: 9999;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0,0,0,.7);\r\n}\r\n\r\n.oh_loader_AAA {\r\n\ttext-align: center;\r\n\tfont-family: 'CaviarDreams';\r\n}\r\n\r\n.oh_loader_img {\r\n\tfont-weight: 300;\r\n\twidth: 100px;\r\n}\r\n\r\n.oh_loader_AAAB {\r\n\tposition: absolute;\r\n\ttop: 0px;\r\n\tright: 0px;\r\n}\r\n\r\n.oh_carga_Bor {\r\n\tpadding: 15px;\r\n}\r\n\r\n/* Personalizacion boostrap */\r\n\r\n.content {\r\n    height: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/carlos/wks/web/vacios_web/src/app/loader/oh.loader.css
// module id = ../../../../../src/app/loader/oh.loader.css
// module chunks = main